import React from 'react';
import * as S from './styled';
export const EntityTableCell = ({ top, bottom, image }) => {
    return (React.createElement(S.Container, null,
        image !== undefined && (React.createElement(S.ImageContainer, { "data-testid": "EntityTableCell.ImageContainer" }, image)),
        React.createElement(S.Content, null,
            React.createElement(S.TopContainer, null, top),
            bottom !== undefined && (React.createElement(S.BottomContainer, { "data-testid": "EntityTableCell.BottomContainer" }, bottom)))));
};
